import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';

export const LPMUKP = () => {

  const navigate = useNavigate();
  const {profileMe} = useSelector((state) => state.profile);
  const {key} = useLocation();

  const baseServerUrl = 'https://portal-dss.kkp.go.id';
  const libraryName = 'MicroStrategyLibrary';

  async function runCode() {
    // https://{env-url}/{libraryName}/app/{projectId}/{dossierId}
    let url =
      baseServerUrl +
      '/' +
      libraryName +
      '/app/C1100275D3469EEB9F13A1B4D7576AED/CFDAF717FD441D7F7AF89EA53EEE113A/K53--K46?continue';

    let dossier; // Variable to store the dashboard created. Used by Event Handler do not remove!
    let config; // Variable to store the configuration settings for dashboard.
    config = {
      url: url,
      placeholder: document.getElementById('embedding-dossier-container'),
      containerHeight: '100%',
      containerWidth: '900px',
      customAuthenticationType:
        microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN,
      enableCustomAuthentication: true,
      enableResponsive: true,
      getLoginToken: login(),
      navigationBar: {
        enabled: false,
      },
    };
    // For more details on configuration properties, see https://www2.microstrategy.com/producthelp/Current/EmbeddingSDK/Content/topics/dossier_properties.htm

    // Embed the dashboard with the configuration settings
    try {
      const placeholderDiv = document.getElementById(
        'embedding-dossier-container',
      );
      microstrategy.dossier.create({
        placeholder: placeholderDiv,
        url: url,
        config: config,
      });
    } catch (error) {
      console.error(error);
    }
  }

  async function getAuthToken() {
    const options = {
      method: 'GET',
      credentials: 'include', // Including cookie
      mode: 'cors', // Setting as cors mode for cross origin
      headers: {'content-type': 'application/json', 'Accept': 'application/json',},
    };

    return await fetch(
      baseServerUrl + '/' + libraryName + '/api/auth/token',
      options,
    )
      .then((response) => {
  

       
        if (response.ok) {


          return response.headers.get('x-mstr-authtoken');}
        else response.json().then((json) => {
          if(json.code === 'ERR009') return null
        });
      })
      .catch((error) =>
        console.error('Failed to retrieve authToken with error:', error),
      );
  }

  // Create new authToken
  async function createAuthToken() {
    // Make a call to REST API to log the user in, if there is not a valid authToken
    const options = {
      method: 'POST',
      credentials: 'include', // Including cookie
      mode: 'cors', // Setting as cors mode for cross origin
      headers: {'content-type': 'application/json'},
      body: JSON.stringify({
        loginMode: 1, // 1 means Standard login
        // loginMode: 16, // 16 means LDAP login
        username: 'demo', // use guest / no password to test
        password: 'password123',
      }),
    };
    return fetch(baseServerUrl + '/' + libraryName + '/api/auth/login', options)
      .then((response) => {
       

        if (response.ok) {
          runCode()
          return response.headers.get('x-mstr-authtoken');
        } else response.json().then((json) => console.log(json));
      })
      .catch((error) =>
        console.error('Failed Standard Login with error:', error),
      );
  }

  // Reuse login session. If not found, create a new authToken.
  async function login() {
    let authToken = await getAuthToken().catch((error) => console.error(error));
    // If the authToken is available, return it

    if (!!authToken) {

      return authToken;
    }
    return await createAuthToken();
  }

  useEffect(() => {
    if (profileMe) {
      let roles = profileMe.roles_coofis ? profileMe.roles_coofis : [];
      const idx = roles.findIndex(
        (x) =>

          x.state === 'LPMUKP_DASHBOARD'
    
      );
      if (idx > -1 && key !== 'default') runCode();
      else navigate('/kkp');
    }
  }, []);



  return <div className='w-100 h-100' id='embedding-dossier-container'></div>;
};
